module.exports = __webpack_public_path__ + "static/media/1b3078ef-2971-4c95-b6ca-13ab528758cb.8c2b03e3.woff";